import { render, staticRenderFns } from "./baseSelectTag.vue?vue&type=template&id=608cc79f&scoped=true&"
import script from "./baseSelectTag.vue?vue&type=script&lang=ts&"
export * from "./baseSelectTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608cc79f",
  null
  
)

export default component.exports